<template>
<!-- eslint-disable vue/valid-v-slot -->
    <v-dialog max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="show" persistent >
      <v-card class="rounded-card">
        <v-system-bar color="warning" height="60px" class="black--text">
           <span class="headline font-weight-bold ms-2">{{$t('Manually Report Wagon Production')}}</span>
        </v-system-bar>
        <v-card-text>
          <v-layout wrap class="my-3">
            <v-flex xs12>
              <span>{{$t('Use this dialog to record production row 1')}}<br />
              {{$t('Use this dialog to record production row 2')}} </span>
            </v-flex>
          </v-layout>
          <v-row no-gutters>
            <v-col cols="12" sm="5">
              <PickDate v-model="produceDate" @input="dateChanged" :label="$t('Production Time')"> </PickDate>
            </v-col>
            <v-col cols="12" sm="5" offset="2">
              <v-select flat class="pe-1" :items="dropdown_wagons" v-model="wagonId"
                v-on:change="fillFeedValues"
                :label="$t('Wagon')" :hint="$t('select a planned wagon to work from')">
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" sm="5">
              <v-text-field :label="$t('TMR')" :value="tmrLongName" readonly></v-text-field>
            </v-col>
            <v-col cols="12" sm="5" offset="2">
              <v-switch v-model="tmr.toFloor"
                :label="$t('Unload to Floor')"
                :hint="$t('Mark to increase TMR inventory')" color="primary" class="ps-3" >
              </v-switch>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="tmr.feeds"
            item-key="idx"
            disable-pagination
            fixed-header
            disable-sort
            hide-default-header
            hide-default-footer
            :no-data-text="$t('No Feeds planned this TMR')"
            class="mx-10"
            >
            <!-- <template v-slot:item.action="{ item }">
              <v-icon small color="primary lighten-2" class="mx-3" @click="editFeedItem(item)">mdi-pencil</v-icon>
            </template> -->
            <template v-if="$vuetify.breakpoint.smAndUp" v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th v-for="hdr in headers" :key="hdr.index"
                    class="subtitle-2 font-weight-bold"
                    :class="{'text-right': hdr.align == 'right', 'text-center': hdr.align == 'center'}" >
                    {{hdr.text.toUpperCase()}}
                  </th>

                </tr>
              </thead>
            </template>

            <template v-slot:item.qty="props">
              <v-edit-dialog :return-value.sync="props.item.qty" large persistent @save="save" @cancel="cancel">
                <div>{{ props.item.qty | kgString}}</div>
                <template v-slot:input>
                  <v-text-field v-model="props.item.qty" :label="$t('Qty_Kg')" single-line autofocus></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:footer>
              <v-row v-if="tmr && tmr.feeds && tmr.feeds.length > 0" justify="end">
                <v-col cols="3">
                  <v-text-field :value="sumQty | kgString"
                    readonly dense hide-details :append-icon="qtyChanged">
                  </v-text-field>
                </v-col>
              </v-row>
            </template>

        </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Cancel') + " "+ $t('exit without saving')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveTrans">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save transaction')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
//import _ from "lodash";
import PickDate from "../components/common/PickDate";
export default {
    name:
      "ManualWagonDialog",
    components: {
      "PickDate": PickDate
    },
    props: {
      value: Boolean,
      feedId: String
    },
    data() {
    return {
      wagonId: "",
      tmr: {},
      produceDate: new Date().toISOString().substr(0, 10),
      headers: [
        { text: this.$i18n.t('Code'), align: "left", value: "code" },
        { text: this.$i18n.t('Name'), width: "25%", value: "name" },
        { text: this.$i18n.t('Qty_Kg'), align: "right", value: "qty" },
        // { text: " ", value: "action", sortable: false },
      ],
    }
  },
  computed: {
    show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit("input", value);
        }
    },
    unit() {
      return this.$store.getters.getWeightUnit;
    },
    dropdown_wagons() {
      return this.$store.getters.getWagons.map((x) => {
            return { text: x.name + " [" + x.tmr.code + "]", value: x.id }
        });
    },
    wagon() {
      if (this.wagonId)
        return this.$store.getters.getWagon(this.wagonId);
      else
        return {name: '', tmr: {code: '', name:''}}
    },
    tmrLongName() {
      return this.tmr.code ? this.tmr.code + ' - ' + this.tmr.name : "";
    },
    sumQty() {
      if (this.tmr.feeds)
        return this.tmr.feeds.reduce((a,b)=> a + Number(b.qty), 0);
      else
        return 0;
    },
    totalQty() {
      if (this.wagon && this.wagon.onlyForDays) {
        const weekQty = this.$store.getters.weekdayQty(this.wagon);
        const dayIndex = new Date(this.produceDate).getDay();
        return weekQty[dayIndex];
      }
      else
        return 0;
    },
    qtyChanged() {
      return (this.sumQty > this.totalQty+1 ? "mdi-arrow-up-bold" : this.sumQty < this.totalQty-1 ? "mdi-arrow-down-bold" : "");
    }
  },
  methods: {
    fillFeedValues: function(event) {
      this.wagonId = event;
      const _tmr = this.$store.getters.getTMR(this.wagon.tmr.documentID);
      const _doses = this.$store.getters.getDosesFromQty(this.totalQty, this.wagon.tmr.documentID);
      this.tmr = {
        Id: _tmr.Id,
        code: _tmr.code,
        name: _tmr.name,
        feeds: _tmr.feeds.map((x, i) => {
          return { idx: i, code: x.code, name: x.name, qty: Math.round(x.qty * _doses), Id: x.feed.id}
        })
      }
    },
    save() {
      //do nothing.
    },
    cancel() {
      //do nothing.
    },
    dateChanged() {
      this.fillFeedValues(this.wagonId);
    },
    clearData() {
      this.wagonId = "";
      this.tmr = {};
      this.show=false;
    },
    CancelDialog() {
      this.clearData();
      this.$emit("close");
    },
    SaveTrans() {
      if (this.tmr && this.tmr.feeds.length > 0) {
        this.$store.dispatch("saveManualWagonTrans", {...this.tmr, prodTime: this.produceDate, sum: this.sumQty, wagonId: this.wagonId}).then(() =>
        {
          this.$root.$globalSnackbar(this.$i18n.t('Transaction saved sussfully'), "success");
          this.clearData();
          this.$emit("close");
        })
        //.catch((e) => {
        .catch(() => {
          this.$root.$globalSnackbar(this.$i18n.t('Error Saving transaction'), "error");
          //console.error("Error when saving buy:", this.purchase, e);
        });
      } else {
        this.$root.$globalSnackbar(this.$i18n.t('Must select a wagon and at least one feed'), "error")
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
        if (this.show && e.keyCode == 27) {
          this.CancelDialog();
        }
      });
    },
}
</script>

<style>

</style>